import type { ReactNode } from "react";

export type SettingsGroupProps = {
  title: string;
  /** 17px stroke SVG inheriting currentColor. */
  icon: ReactNode;
  /** Chip tint. "warm" for the destructive "Account beheren" group. */
  tone?: "accent" | "warm";
  children: ReactNode;
};

/**
 * Grouped settings card — icon chip + title header over a stack of SettingsRow.
 * Rows render their own bottom borders (last:border-b-0).
 */
export function SettingsGroup({ title, icon, tone = "accent", children }: SettingsGroupProps) {
  const chip =
    tone === "warm"
      ? "bg-[var(--warm-soft)] text-[var(--warm)]"
      : "bg-[var(--accent-soft)] text-[var(--accent)]";

  return (
    <section className="overflow-hidden rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--panel)] shadow-[var(--shadow)]">
      <div className="flex items-center gap-2.5 border-b border-[var(--border)] px-5 pt-4 pb-3 sm:px-6">
        <span className={`grid h-[30px] w-[30px] flex-none place-items-center rounded-[9px] ${chip}`}>
          {icon}
        </span>
        <h3 className="text-base text-[var(--ink)]">{title}</h3>
      </div>
      <div>{children}</div>
    </section>
  );
}
